export default {
  updateToken(state, token) {
    state.token = token
  },
  updateAsuToken(state, asuToken) {
    state.asuToken = asuToken
  },
  setWorkspace(state, payload) {
    state.workspace = payload
  },
  setLastOpenedWorkspace(state, payload) {
    state.lastOpenedWorkspace = payload
    localStorage.setItem('lastOpenedWorkspace', payload)
  },
  setWorkspaceList(state, workspaceList) {
    state.workspaceList = workspaceList
  },
  setActiveWorkspaceList(state, workspaceList) {
    state.activeWorkspaceList = workspaceList
  },
  setVersion(state, payload) {
    state.version = payload
  },
  setVersionList(state, versionList) {
    state.versionList = versionList
  },
  setLastTimeVersionRequest(state, time) {
    state.lastTimeVersionRequest = time
  },
  setVersionRequestInterval(state, interval) {
    state.versionRequestInterval = interval
  },
  setNewVersionExists(state, payload) {
    state.newVersionExists = payload
  },
  setIsVersionCopying(state, isVersionCopying) {
    state.isVersionCopying = isVersionCopying
  },
  setIsWorkspaceCopying(state, isWorkspaceCopying) {
    state.isWorkspaceCopying = isWorkspaceCopying
  },

  /**
   * Установка прав пользователя
   * @param {*} state
   * @param {*} permissions
   */
  setPermissions(state, permissions) {
    state.permissions = permissions
  },

  /**
   * Установка специального промиса загрузки данных пользователя
   * @param {*} state
   * @param {*} userDataPromise
   */
  setUserDataPromise(state, userDataPromise) {
    state.userDataPromise = userDataPromise
  },

  /**
   * Установка данных пользователя
   * @param {*} state
   * @param {*} param1
   */
  setUserData(state, { userName, userId, userGroups, userDepartments, userAvailableVersions }) {
    state.userId = userId
    state.userName = userName
    state.userGroups = userGroups
    state.userDepartments = userDepartments
    state.userAvailableVersions = userAvailableVersions
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/mutations.js